import { Component, ElementRef, OnDestroy, OnInit } from "@angular/core"
import { Observable, Subscription } from "rxjs"
import { UserService } from "../../../services/user.service"
import { WindowSizeService } from "../../../services/window-size.service"
import { CardComponent } from "../card.component"
import { PreviewService } from "../../../services/preview.service"
import { routeAnimations, routeTransition } from "../../../utils/animations"

@Component({
    selector: "app-ymal-card",
    templateUrl: "./ymal-card.component.html",
    styleUrls: ["./ymal-card.component.scss"],
    host: { "[@routeTransition]": "true", "[@routeAnimations]": "false", style: "display: block;" },
    animations: [routeTransition, routeAnimations],
    standalone: false,
})
export class YmalCardComponent extends CardComponent implements OnInit, OnDestroy {
    public ymalClass: number = 0
    public subs: Subscription[] = []
    isInPreviewMode$: Observable<boolean>

    constructor(
        public userService: UserService,
        private element: ElementRef,
        private windowSize: WindowSizeService,
        public previewService: PreviewService
    ) {
        super(userService)
    }

    public ngOnInit(): void {
        this.isInPreviewMode$ = this.previewService.previewOnCollection$

        setTimeout(() => {
            this.ymalClass = this.element.nativeElement.firstChild.clientWidth
        })

        this.subs.push(
            this.windowSize.resize.subscribe(
                () => (this.ymalClass = this.element.nativeElement.firstChild.clientWidth)
            )
        )
    }

    public ngOnDestroy() {
        this.subs.forEach((sub: Subscription) => sub.unsubscribe())
    }

    public isCardLarge(): boolean {
        return this.ymalClass >= 376
    }
}
